import { Delimiters } from './interfaces';
import { interpolateContent } from '../../utils/interpolateContent';
export var parseHeaderContent = function parseHeaderContent(_ref) {
  var text = _ref.text,
    price = _ref.price,
    cadence = _ref.cadence,
    priceWithDiscount = _ref.priceWithDiscount,
    isCouponApplied = _ref.isCouponApplied;
  var showDiscountStrings = isCouponApplied && !!priceWithDiscount && text.includes(Delimiters.priceWithDiscount);
  var delimiter = showDiscountStrings ? Delimiters.priceWithDiscount : Delimiters.price;
  if (!text.length) return '';
  if (showDiscountStrings) {
    return parseCouponHeaderContent(text, priceWithDiscount);
  } else if (text.includes(delimiter)) {
    return interpolateContent(text, [{
      key: delimiter,
      value: price,
      formatPrefix: '<span class="headerPriceSection">',
      formatSuffix: ''
    }, {
      key: Delimiters.cadence,
      value: cadence,
      formatPrefix: '',
      formatSuffix: ''
    }]).concat('</span>');
  } else {
    return text;
  }
};
export var parseCouponHeaderContent = function parseCouponHeaderContent(text, priceWithDiscount) {
  if (!text.length) return '';
  return priceWithDiscount ? interpolateContent(text, [{
    key: Delimiters.priceWithDiscount,
    value: priceWithDiscount,
    formatPrefix: '<span class="headerPriceSection withCoupon"><strong>',
    formatSuffix: '</strong>'
  }]).concat('</span>') : text;
};
export var parseSubHeaderContent = function parseSubHeaderContent(_ref2) {
  var text = _ref2.text,
    price = _ref2.price,
    cadence = _ref2.cadence,
    isCouponApplied = _ref2.isCouponApplied;
  if (!text.length) return '';
  return isCouponApplied ? interpolateContent(text, [{
    key: Delimiters.price,
    value: price,
    formatPrefix: '',
    formatSuffix: ''
  }, {
    key: Delimiters.cadence,
    value: cadence,
    formatPrefix: '',
    formatSuffix: ''
  }]) : text;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SubscriptionInfo/helper.js
// module id = 3996
// module chunks = 11